import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/news';

export default {
    getAllNews: (token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}/getnewsoverviewbyuser`, token);
        });
    },
    getNewsFileByFileId: (id, token) => {
        return req(token).then((token) => {
            return Request.get(`gallery/getfilecontent?id=${id}&returnImageAsType=2`, token);
        });
    },
    getNewsThumbnailByFileId: (id, token) => {
        return req(token).then((token) => {
            return Request.get(`gallery/getfilethumbnailcontent?id=${id}&size=100x100&returnImageAsType=2`, token);
        });
    },
};
